export enum WidgetScope {
  NATIONAL = 'NATIONAL',
  REGIONAL = 'REGIONAL',
}
